import { dateLocaleFor } from "@/lib/period-label";

/**
 * Adds calendar days to an ISO date (`YYYY-MM-DD`). Experiment dates are
 * calendar dates judged in UTC (see `experimentPhase` in @graftus/schema), so
 * the arithmetic is done in UTC too: mixing `setDate` (local) with
 * `toISOString` (UTC) lands a day short whenever a DST change falls inside
 * the window for users west of UTC.
 */
export function addDays(isoDate: string, days: number): string {
  const d = new Date(`${isoDate}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

/** "20 Sep 2026" / "20 sep. 2026" instead of the raw ISO string. */
export function formatIsoDate(isoDate: string, language: string): string {
  const d = new Date(`${isoDate}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return isoDate;
  return d.toLocaleDateString(dateLocaleFor(language), {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}
